module.exports = __webpack_public_path__ + "static/img/404_img01.9e2b12f1.png";